import type { ImageScene } from '@acasa/shared'

/**
 * German display labels. The catalogue itself — every operation and its prompt —
 * lives in `@acasa/shared/image-operations`, because the API builds the prompt.
 */
export const SCENE_LABELS: Record<ImageScene, string> = {
  interior: 'Innenaufnahme',
  exterior: 'Außenansicht',
}

export const STATUS_LABELS: Record<string, string> = {
  queued: 'In Warteschlange',
  running: 'Wird bearbeitet',
  succeeded: 'Fertig',
  failed: 'Fehlgeschlagen',
}
